import * as React from 'react';
import { GroupResource } from '../../../../../../GroupsStore/Types';
import ManageLink from './ManageLink';
import { observer } from 'mobx-react';
import Edit from './Edit';

export interface Props {
  resource: GroupResource;
}

const Actions: React.FC<Props> = ({ resource }) => (
  <>
    <ManageLink resource={resource} />
    <Edit resource={resource} />
  </>
);

export default observer(Actions);
